import { t } from "@lingui/macro";

export const GPT_POST_FRAMEWORKS = [
  {
    id: "random",
    getDisplayName: () => t`Random`,
  },
  {
    id: "pastor",
    getDisplayName: () => "PASTOR",
  },
  {
    id: "pas",
    getDisplayName: () => "PAS",
  },
  {
    id: "aida",
    getDisplayName: () => "AIDA",
  },
  {
    id: "fab",
    getDisplayName: () => "FAB",
  },
] as const;
